export const SUPPORTED_LANGS = ["en", "fr", "ar", "es", "it", "de", "nl"] as const;
export type Lang = (typeof SUPPORTED_LANGS)[number];
export const DEFAULT_LANG: Lang = "en";
export const RTL_LANGS: readonly Lang[] = ["ar"];

export function isLang(value: unknown): value is Lang {
  return typeof value === "string" && (SUPPORTED_LANGS as readonly string[]).includes(value);
}

export function parseLang(value: unknown): Lang {
  return isLang(value) ? value : DEFAULT_LANG;
}

/**
 * The locale to read DB content in, from an i18next language tag.
 *
 * Strips the region — a browser reporting `de-CH` still reads German — and
 * falls back to English for anything we do not publish. This lives here rather
 * than beside each renderer because it was written twice and the copies drifted:
 * the mobile app's knew only en/fr/ar, so a German traveller got a German
 * interface wrapped around English highlights and English good-to-know on every
 * activity, while the website read all seven.
 */
export function pickContentLang(tag: string | null | undefined): Lang {
  const base = (tag ?? "").split("-")[0]?.toLowerCase() ?? "";
  return isLang(base) ? base : DEFAULT_LANG;
}

/** Fresh regex (avoids stateful global flag) matching a leading `/<lang>` path segment. */
export function langSegmentRegex(): RegExp {
  return new RegExp(`^/(${SUPPORTED_LANGS.join("|")})(?=/|$)`);
}

export const OG_LOCALE: Record<Lang, string> = {
  en: "en_US",
  fr: "fr_MA",
  ar: "ar_MA",
  es: "es_ES",
  it: "it_IT",
  de: "de_DE",
  nl: "nl_NL",
};
